// font awesome
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const navLinks = {
	headerLinks: [
		{
			to: '/yamb',
			name: 'Yamb',
		},
		{
			to: '/100-boxes',
			name: '100 Boxes',
		},
	],

	footerLinks: [
		{
			title: 'Games',
			links: [
				{
					to: '/yamb',
					name: 'Yamb online',
				},
				{
					to: '/100-boxes',
					name: '100 Boxes',
				},
			],
		},
		{
			title: 'contact',
			links: [
				{
					icon: faEnvelope,
					href: 'mailto:hello@fatcatremote.com',
					name: ' hello@fatcatremote.com',
				},
			],
		},
	],
};

export default navLinks;
